module.exports = __webpack_public_path__ + "static/media/list-bullet.e232dc42.svg";